import { h, Component } from 'preact';
import {Form, I18n, FormEntry, Button, Col, Row, Container} from 'components/elements'
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import style from './index.less'
import {
    AccountActions,
    PageActions,
    SessionActions
} from 'actions'
import { formatPhoneNumber } from 'lib/helpers';
import store from 'reducers'

@Form
@connect((state)=> state)
export default class ResetPrompt extends WidgetComponent {
    constructor(props, context){
        super(props, context)
        this.state = {
            passwordError: false,
            resetError: false,
            resetSent: false,
            value: ''
        }

        this.handleBackToLogin = this.handleBackToLogin.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleResetPassword = this.handleResetPassword.bind(this)
    }
    handleResetPassword(){
        let optional = {}
        if(this.props.config.type){
            optional.type=this.props.config.type
        }
        AccountActions.resetPassword({
            authenticators: {
                email: this.props.session.account.email,
                mobilePhone: this.props.session.account.mobilePhone
            }, 
            url: location.protocol + '//' + location.host + location.pathname, 
            organizationID: this.props.organization.id,
            ...optional
        }).then((response)=>{
            this.setState({
                resetSent: true
            })
        }).catch((e)=>{
            this.setState({
                resetError: true
            })
        })
    }
    handleChange(e){
        if(this.state.passwordError){
            this.setState({
                passwordError: false
            })
        }
        if(e.target.name == 'value'){
            this.setState({
                value: e.target.value,
                resetError: false
            })
        }
    }
    handleBackToLogin(e){
        SessionActions.setAuthenticationMode('login')
        PageActions.navToLogin()
    }
    get validAuthenticators(){
        const authenticators = {}
        if(this.props.session.account.email){
            authenticators.email = this.props.session.account.email
        }
        if(this.props.session.account.mobilePhone){
            authenticators.mobilePhone = this.props.session.account.mobilePhone
        }

        return authenticators;
    }
    get isEmailValid(){
        return !!this.props.session.account.email
    }
    render(){
        const {InputDark, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleResetPassword}>
                <Row class={this.props.class}>
                    <Col span={{sm:'hidden', md:5}}></Col>
                    <Col span={{sm:24, md:14}}>
                        <Container>
                            <Row>
                                <Col span={{md:1}}></Col>
                                <Col span={{sm:24, md:22}} class={style.noPadding}>     
                                    <h2>
                                        {this.props.session.authenticationMode == 'reset' && 
                                            'Password Your Reset'
                                        }
                                        {this.props.session.authenticationMode == 'claim' && 
                                            'Claim Your Account'
                                        }
                                    </h2>
                                    <br />
                                    <strong>
                                        Please confirm your contact information:
                                    </strong>
                                    <br />
                                    <div style={{padding: "10px 0px 40px 20px"}}>
                                        {this.props.session.account.email && 
                                            <div>
                                                <strong>
                                                    Email: {this.props.session.account.email}
                                                </strong>
                                                <br />
                                            </div>
                                        }
                                        {this.props.session.account.mobilePhone && 
                                            <div>
                                                <strong>
                                                    Mobile Phone: {formatPhoneNumber(this.props.session.account.mobilePhone)}
                                                </strong>
                                                <br />
                                            </div>
                                        }
                                    </div>

                                    <div class={style.errorSpacing}>
                                            {this.state.resetError && 
                                                <div class={style.errorMessage}>There was error attempting to 
                                                    {this.props.session.authenticationMode == 'claim' && (
                                                        ' claim your account. Please try again later.'
                                                    )}
                                                    {this.props.session.authenticationMode == 'reset' && (
                                                        ' reset your password. Please try again later.'
                                                    )}
                                                    </div>
                                            }
                                    </div>
                                    <strong>
                                        {this.state.resetSent ? (
                                            <div class={style.resetSent}>
                                                An email or text has been sent with further instructions.
                                            </div>
                                        ):(
                                            <div class={style.resetPassword} onClick={this.handleBackToLogin}>
                                                Back to Log In
                                            </div>
                                        )}
                                    </strong>
                                </Col>
                            </Row>
                            {!this.state.resetSent &&
                                <Row>
                                    <Col span={{sm:6, md:8}}></Col>
                                    <Col span={{sm:12, md:8}}>
                                        <div class={style.searchButton}>
                                            <Button>
                                                {this.props.session.authenticationMode == 'reset' && 
                                                    'Continue'
                                                }
                                                {this.props.session.authenticationMode == 'claim' && 
                                                    'Continue'
                                                }
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </Container>
                    </Col>
                </Row>
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./components/partials/ResetPasswordPrompt/index.js